module.exports = __webpack_public_path__ + "img/esp.5b3a2599.svg";